<template>
    <div class="flex flex-col gap-1">
        <FloatLabel variant="on">
            <slot name="content"></slot>
            <label>{{ props.itemLabel }}</label>
        </FloatLabel>
        <Message v-if="props.isInvalid" severity="error" size="small" class="pl-2" variant="simple">{{
            props.errorMessage
        }}</Message>
    </div>
</template>

<script setup>
import { FloatLabel } from "primevue";
import { Message } from "primevue";
import { defineProps } from "vue";

const props = defineProps({
    itemLabel: { type: String, default: "" },
    isInvalid: { type: Boolean, default: false },
    errorMessage: { type: String, default: "" },
});
</script>

<style scoped></style>
